import * as React from 'react';
export const calculatorSvg = React.forwardRef(function calculatorSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.75 10.75c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 0 .559.441 1 1 1Zm-5.5 0c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 .01.559.451 1 1 1Zm2.75 0c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 .01.559.451 1 1 1ZM10.75 8c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 0 .559.441 1 1 1Zm-5.5 0c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 .01.559.451 1 1 1ZM8 8c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 .01.559.451 1 1 1Zm2.75 5.5c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 0 .559.441 1 1 1Zm-5.5 0c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 .01.559.451 1 1 1Zm2.75 0c.549 0 1-.451 1-1 0-.549-.451-1-1-1-.549 0-1 .451-1 1 .01.559.451 1 1 1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 14V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2ZM3.5 3V2a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v1h-9Zm0 1.5V14a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4.5h-9Z',
    }),
  );
});
calculatorSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var calculator = {
  category: 'icon',
  colorable: true,
  name: 'calculator',
  svg: calculatorSvg,
};
